@import '../../../constants/spacing.module.less';

.content-container {
  display: flex;
  min-height: 500px;
  margin-top: @space-16;
  gap: @space-16;
}

.tree-section {
  overflow-y: hidden;
  flex: 0 0 30%;
  display: flex;
  flex-direction: column;
}

.tree-title {
  margin-bottom: @space-4;
}

.tree-container {
  flex: 1;
  overflow-y: auto;
  padding: @space-8;
  border: 1px solid var(--grey-300);
}

.expression-section {
  flex: 1 1 70%;
  overflow-y: auto;
}

.textarea {
  width: 100%;
  padding: @space-16;
  border: 1px solid var(--grey-300);
  resize: vertical;
  min-height: 200px;

  &:focus {
    outline: 2px solid var(--blue-500);
    outline-offset: -2px;
  }
}

.introduction {
  margin-top: @space-16;
}

.example {
  margin: 0;
  color: var(--grey-700);
}
